// Toast notification component

let toastCounter = 0;

/**
 * Show a toast notification
 * @param {string} message - Message to display
 * @param {string} type - Type: 'success', 'error', 'warning', 'info'
 * @param {number} duration - Duration in ms (default 3000)
 */
export function showToast(message, type = 'info', duration = 3000) {
    const container = document.getElementById('toast-container') || createToastContainer();

    const toastId = `toast-${++toastCounter}`;

    const toast = document.createElement('div');
    toast.id = toastId;
    toast.className = `toast toast-${type}`;

    const icon = getToastIcon(type);

    toast.innerHTML = `
    <span class="toast-icon">${icon}</span>
    <span class="toast-message">${message}</span>
    <button class="toast-close" onclick="closeToast('${toastId}')">&times;</button>
  `;

    container.appendChild(toast);

    // Auto remove
    setTimeout(() => {
        closeToast(toastId);
    }, duration);

    return toastId;
}

/**
 * Close a toast by ID
 * @param {string} toastId - Toast ID to close
 */
export function closeToast(toastId) {
    const toast = document.getElementById(toastId);
    if (toast) {
        toast.classList.add('toast-exit');
        setTimeout(() => {
            toast.remove();
        }, 300);
    }
}

// Make closeToast available globally
window.closeToast = closeToast;

/**
 * Create toast container if not exists
 */
function createToastContainer() {
    let container = document.getElementById('toast-container');
    if (!container) {
        container = document.createElement('div');
        container.id = 'toast-container';
        container.className = 'toast-container';
        document.body.appendChild(container);
    }
    return container;
}

/**
 * Get icon for toast type
 * @param {string} type - Toast type
 * @returns {string} Icon emoji
 */
function getToastIcon(type) {
    switch (type) {
        case 'success': return '✓';
        case 'error': return '✕';
        case 'warning': return '⚠';
        case 'info':
        default: return 'ℹ';
    }
}

/**
 * Show success toast
 */
export function showSuccess(message, duration) {
    return showToast(message, 'success', duration);
}

/**
 * Show error toast
 */
export function showError(message, duration) {
    return showToast(message, 'error', duration);
}

/**
 * Show warning toast
 */
export function showWarning(message, duration) {
    return showToast(message, 'warning', duration);
}

/**
 * Show info toast
 */
export function showInfo(message, duration) {
    return showToast(message, 'info', duration);
}
